<template>
  <div>
    <v-card class="px-9 py-11 my-6" style="border-radius: 15px">
      <h1>Hi [full_name],</h1>
      <span class="span_one"
        >Follow the link below to unlock your account. If you didn't request a
        reset, you can ignore this message.</span
      >
      <v-btn block color="primary" to="/forgetpassword2" class="py-5 my-9"
        ><span class="white--text text_style">RECOVER PASSWORD</span></v-btn
      >
      <v-divider></v-divider>
      <div class="mt-6 mb-4">
        <span class="h1_Two">Any concerns?</span>
      </div>
      <div >
        <span class="h1_Two_span primary--text">Contact our support</span>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "DetailsForgetPasswordComponent",
};
</script>

<style scoped>

h1 {
  font-family: "DM Sans";
  font-size: 24px;
  font-weight: 500;
  color: #222222;
}
.span_one {
  font-family: "DM Sans";
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.7);
}
.h1_Two {
  font-family: "DM Sans";
  font-size: 26px;
  font-weight: 700;
}
.h1_Two_span {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 400;
}
</style>
